<template>
  <div class="workbench-container">
    <HeaderCard />
    <div class="workbench">
      <!-- <div class="flex-container gap-10">
        <div class="flex-item-2">
          <EnterpriseWarRoom
            :key="agentId"
            :agent-id="agentId"
            @open-detail="$emit('open-detail', $event)"
            @open-list="$emit('open-list', $event)"
            @smart-analysis="$emit('smart-analysis', $event)"
            @start-chat="$emit('start-chat', $event)"
          />
        </div>
        <div class="flex-item">
          <TaskQueue
            :key="agentId"
            :agent-id="agentId"
            @open-detail="(taskData) => $emit('task-open-detail', taskData)"
            @open-list="$emit('task-open-list', $event)"
          />
        </div>
      </div> -->
      <div v-if="isCeoDemo" class="grid-container grid-1 gap-10">
        <BusinessIndicatorsYs :key="agentId" @smart-analysis="$emit('smart-analysis', $event)" />
      </div>
      <div v-else-if="isLqz" class="grid-container grid-1 gap-10">
        <BusinessIndicatorsLQZ @smart-analysis="$emit('smart-analysis', $event)" />
      </div>
      <div v-else class="grid-container grid-1 gap-10">
        <BusinessIndicators :key="agentId" @smart-analysis="$emit('smart-analysis', $event)" />
      </div>
     <div v-if="!isCeoDemo" class="grid-container grid-1 gap-10">
        <BusinessChainAnalysis :key="agentId" @smart-analysis="$emit('smart-analysis', $event)" />
     </div>
     <div v-if="isLqz" class="grid-container grid-3 gap-10">
        <CardLqzqy />
        <CardLqzsr />
        <CardLqzmll />
      </div>
     <div v-else-if="!isCeoDemo" class="grid-container grid-1-2 gap-10">
        <OperatingReport @open-tool="$emit('open-tool', $event)" />
       <!-- <CostAnalysis /> -->
        <Card1 :key="agentId" />
       <!-- <KpiIndicators /> -->
      </div>
      <div v-else class="grid-container grid-3 gap-10">
        <!-- <OperatingReport v-if="!isCeoDemo" @open-tool="$emit('open-tool', $event)" /> -->
       <CostAnalysis :key="agentId" />
        <!-- <Card1 v-if="!isCeoDemo" /> -->
       <KpiIndicators :key="agentId" />
       <StrategyProgress :key="agentId" />
      </div>
      <div v-if="isCeoDemo" class="grid-container grid-2-1 gap-10">
        <OrderCapacity :key="agentId" />
        <MainSuppliers :key="agentId" />
        <!-- <YoyCompare :key="agentId" /> -->
      </div>
      <div v-if="isCeoDemo" class="grid-container grid-1 gap-10">
        <!-- <DigitalTwin :key="agentId" /> -->
        <YoyCompare :key="agentId" />
      </div>
    </div>
  </div>
</template>

<script>
// // import WelcomeCard from '../components/WelcomeCard.vue'
// import AlertCard from '../components/AlertCard.vue'
// // import QuickActionCard from '../components/QuickActionCard.vue'
// import BusinessCard from '../components/BusinessCard.vue'
// import CostAnalysisCard from '../components/CostAnalysisCard.vue'
// import KPICard from '../components/KPICard.vue'
// import ReportCard from '../components/RevenueTrendCard.vue'
// import DepartmentCard from '../components/DepartmentProgressCard.vue'
import { getAgentIdByInternalName } from '@/store/modules/cosmoClaw'
import BusinessIndicators from '../components/businessIndicators.vue'
import BusinessIndicatorsLQZ from '../components/businessIndicatorsLQZ.vue'
import BusinessChainAnalysis from '../components/BusinessChainAnalysis.vue'
import CostAnalysis from '../components/costAnalysis.vue'
import OrderCapacity from '../components/orderCapacity.vue'
import MainSuppliers from '../components/mainSupplier.vue'
import YoyCompare from '../components/yoyCompare.vue'
// import StrategyProgress from '../components/strategyProgress.vue'
import StrategyProgress from '../components/mainKehu.vue'
import Card1 from '../components/card1.vue'
import OperatingReport from '../components/OperatingReport.vue'
import KpiIndicators from '../components/kpiIndicators.vue'
// import DigitalTwin from '../components/digitalTwin.vue'
import CardLqzsr from '../components/cardLqzsr.vue'
import CardLqzmll from '../components/cardLqzmll.vue'
import CardLqzqy from '../components/cardLqzqy.vue'

// import EnterpriseWarRoom from '../components/EnterpriseWarRoom.vue'
// import TaskQueue from '../components/TaskQueue.vue'
// import PendingDecision from '../components/PendingDecisions.vue'
import HeaderCard from '../components/HeaderCard.vue'
import BusinessIndicatorsYs from '../components/businessIndicatorsYs.vue'
import { mapState } from 'vuex'

export default {
  name: 'CeoWorkbench',
  components: {
    OrderCapacity,
    MainSuppliers,
    YoyCompare,
    // // WelcomeCard,
    // AlertCard,
    // // QuickActionCard,
    // BusinessCard,
    // CostAnalysisCard,
    // KPICard,
    // ReportCard,
    // DepartmentCard,
    BusinessIndicatorsYs,
    BusinessIndicatorsLQZ,
    StrategyProgress,
    BusinessIndicators,
    BusinessChainAnalysis,
    CostAnalysis,
    Card1,
    CardLqzsr,
    CardLqzmll,
    CardLqzqy,
    OperatingReport,
    KpiIndicators,
    // DigitalTwin,
    // EnterpriseWarRoom,
    // TaskQueue,
    // PendingDecision,
    HeaderCard
  },
  data() {
    return {
      images: require('@/assets/imgs/workbench/ceo.png')
    }
  },
  computed: {
    ...mapState('user', ['agentList']),
    ...mapState('cosmoClaw', ['isCeoDemo', 'isLqz']),
    // 数字人 agentId 优先取 URL query.agentId（同路由多实例切换），无则从 agentList 自动匹配
    agentId() {
      const queryAgentId = (this.$route.query && this.$route.query.agentId) || ''
      if (queryAgentId) {
        const list = Array.isArray(this.agentList) ? this.agentList : []
        const matched = list.find(
          (a) =>
            String(a.id) === String(queryAgentId) ||
            String(a.agentId || '') === String(queryAgentId)
        )
        if (matched) return String(queryAgentId)
      }
      return getAgentIdByInternalName('ceo_shu_zi_ren', this.agentList)
    }
  },
  mounted() {
    if (this.agentId) {
      this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', this.agentId)
    }
  },
  watch: {
    agentId(val) {
      if (val) {
        this.$store.commit('cosmoClaw/SET_CURRENT_AGENT_ID', val)
      }
    }
  },
  methods: {
    handleActionClick(item) {
      console.log('点击快捷操作:', item)
      this.$message.success(`打开${item.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.workbench-container {
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
}
.workbench {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.workbench::-webkit-scrollbar {
  width: 4px;
}
.workbench::-webkit-scrollbar-track {
  background: transparent;
}
.workbench::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.grid-container {
  width: 100%;
  min-width: 700px;
}
.grid-1 {
  display: grid;
  grid-template-columns: 1fr;
}
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.grid-1-2 {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.grid-2-1 {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.flex-container {
  width: 100%;
  min-width: 700px;
  display: flex;
}
.flex-item {
  width: calc((100% - 10px) / 3);
  flex-shrink: 1;
  min-width: 0;
}
.flex-item-2 {
  width: calc((100% - 10px) / 3 * 2);
  flex-shrink: 1;
  min-width: 0;
}
.gap-10 {
  gap: 10px;
}
</style>
